import { render, staticRenderFns } from "./batchAddOption.vue?vue&type=template&id=7aed5c42&"
import script from "./batchAddOption.vue?vue&type=script&lang=js&"
export * from "./batchAddOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports